/* New Chikan Sagar — motion & interaction layer (Shopify theme)
   Lenis (smooth scroll) + anime.js (timelines) + scroll-scrubbed film.
   Every initialiser is idempotent and scoped, so sections re-rendered in the
   theme editor come back to life without a page reload. */
(function () {
  "use strict";
  document.documentElement.classList.remove("no-js");
  var CFG = window.NCS || {};
  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var DESIGN = !!CFG.designMode || !!(window.Shopify && window.Shopify.designMode);
  var ANIM = CFG.animations !== false && !RM && !DESIGN;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var done = new WeakSet();
  function once(el) { if (done.has(el)) return false; done.add(el); return true; }
  function A() { return window.anime; }

  /* ---------------------------------------------------------------- Lenis */
  var lenis = null;
  if (window.Lenis && !RM && !DESIGN && CFG.smoothScroll !== false) {
    lenis = new window.Lenis({ duration: 1.1, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    document.addEventListener("click", function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (id.length > 1 && $(id)) { e.preventDefault(); lenis.scrollTo(id, { offset: -90 }); }
    });
  }
  window.NCS_lenis = lenis;
  function lockScroll(on) {
    document.body.style.overflow = on ? "hidden" : "";
    if (lenis) { if (on) lenis.stop(); else lenis.start(); }
  }
  window.NCS_lockScroll = lockScroll;

  /* --------------------------------------------------------------- Header */
  function initHeader() {
    var hdr = $(".hdr");
    if (!hdr || !once(hdr)) return;
    var onScroll = function () { hdr.classList.toggle("is-stuck", window.scrollY > 12); };
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
  }
  document.addEventListener("click", function (e) {
    var drawer = $("#drawer");
    if (!drawer) return;
    if (e.target.closest("[data-drawer-open]")) { drawer.classList.add("is-open"); lockScroll(true); }
    else if (e.target.closest("[data-drawer-close]")) { drawer.classList.remove("is-open"); lockScroll(false); }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var drawer = $("#drawer");
    if (drawer && drawer.classList.contains("is-open")) { drawer.classList.remove("is-open"); lockScroll(false); }
  });

  /* ------------------------------------------------------- Reveal on view */
  function show(el) { el.style.opacity = 1; el.style.transform = "none"; }
  function playReveal(el) {
    var kind = el.dataset.reveal || "up";
    var delay = parseInt(el.dataset.revealDelay || "0", 10);
    if (!ANIM || !A()) { show(el); return; }
    var from = { targets: el, opacity: [0, 1], duration: 1100, delay: delay, easing: "cubicBezier(.16,1,.3,1)" };
    if (kind === "up") from.translateY = [34, 0];
    else if (kind === "down") from.translateY = [-28, 0];
    else if (kind === "left") from.translateX = [-40, 0];
    else if (kind === "right") from.translateX = [40, 0];
    else if (kind === "scale") { from.scale = [0.94, 1]; from.translateY = [18, 0]; }
    else if (kind === "blur") { from.filter = ["blur(11px)", "blur(0px)"]; from.translateY = [20, 0]; }
    A()(from);
  }
  function playStagger(group) {
    var kids = $$("[data-stagger-item]", group);
    if (!kids.length) return;
    if (!ANIM || !A()) { kids.forEach(function (k) { k.style.opacity = 1; }); return; }
    A()({ targets: kids, opacity: [0, 1], translateY: [40, 0], rotateX: [-10, 0], scale: [0.97, 1],
      duration: 1000, delay: A().stagger(95), easing: "cubicBezier(.16,1,.3,1)" });
  }
  var io = ("IntersectionObserver" in window) ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      if (e.target.hasAttribute("data-stagger")) playStagger(e.target); else playReveal(e.target);
      io.unobserve(e.target);
    });
  }, { rootMargin: "0px 0px -12% 0px", threshold: 0.08 }) : null;
  function initReveals(root) {
    $$("[data-reveal],[data-stagger]", root).forEach(function (el) {
      if (!once(el)) return;
      if (!ANIM || !io) {
        if (el.hasAttribute("data-stagger")) $$("[data-stagger-item]", el).forEach(show); else show(el);
        return;
      }
      if (el.hasAttribute("data-stagger")) $$("[data-stagger-item]", el).forEach(function (k) { k.style.opacity = 0; });
      io.observe(el);
    });
  }
  window.NCS_reveal = initReveals;

  /* ------------------------------------------------- Hero entrance timeline */
  function initHero(root) {
    var hero = $("[data-hero]", root);
    if (!hero || !once(hero) || !ANIM || !A()) return;
    var q = function (s) { return $$(s, hero); };
    var tl = A().timeline({ easing: "cubicBezier(.16,1,.3,1)" });
    tl.add({ targets: q("[data-hero-eyebrow]"), opacity: [0, 1], translateY: [14, 0], duration: 800 })
      .add({ targets: q("[data-hero-line]"), opacity: [0, 1], translateY: [46, 0], rotateX: [-24, 0], duration: 1150, delay: A().stagger(110) }, "-=520")
      .add({ targets: q("[data-hero-sub]"), opacity: [0, 1], translateY: [22, 0], duration: 900 }, "-=760")
      .add({ targets: q("[data-hero-cta] > *"), opacity: [0, 1], translateY: [20, 0], duration: 800, delay: A().stagger(85) }, "-=680")
      .add({ targets: q("[data-hero-feat]"), opacity: [0, 1], translateY: [18, 0], duration: 700, delay: A().stagger(70) }, "-=600")
      .add({ targets: q("[data-hero-img]"), scale: [1.13, 1.06], opacity: [0, 1], duration: 1800 }, 0)
      .add({ targets: q("[data-hero-script],[data-hero-stamp],[data-hero-deco]"), opacity: [0, 1], translateX: [22, 0], duration: 1000, delay: A().stagger(120) }, "-=1100");
  }

  /* ------------------------------------------- Scroll-scrubbed craft film */
  function initScrub(root) {
    $$("[data-scrub-section]", root).forEach(function (sect) {
      if (!once(sect)) return;
      var scrub = $("[data-scrub-video]", sect);
      var steps = $$("[data-step]", sect);
      var fill = $(".steps__fill", sect);
      var prog = $("[data-scrub-prog]", sect);
      if (scrub && RM) { scrub.loop = true; scrub.muted = true; var pr = scrub.play(); if (pr && pr.catch) pr.catch(function () {}); }
      var target = 0, current = 0, ready = !scrub, ticking = false;
      function computeTarget() {
        var r = sect.getBoundingClientRect(), vh = window.innerHeight;
        var total = r.height + vh * 0.7, passed = vh * 0.85 - r.top;
        return Math.max(0, Math.min(1, passed / total));
      }
      function applyTime() {
        if (!scrub || RM || !ready || !scrub.duration || !isFinite(scrub.duration)) return;
        var t = current * (scrub.duration - 0.05);
        if (Math.abs(scrub.currentTime - t) > 0.012) { try { scrub.currentTime = t; } catch (e) {} }
      }
      function tick() {
        ticking = false;
        target = computeTarget();
        current += (target - current) * 0.12;
        applyTime();
        if (prog) prog.style.width = (current * 100).toFixed(2) + "%";
        if (steps.length) {
          var idx = Math.min(steps.length - 1, Math.floor(current * steps.length + 0.0001));
          steps.forEach(function (s, i) { s.classList.toggle("is-on", i === idx); });
          if (fill) fill.style.height = ((idx + 1) / steps.length) * 100 + "%";
        }
        if (Math.abs(target - current) > 0.0008) requestAnimationFrame(tick);
      }
      function request() { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }
      function markReady() { if (ready) return; ready = true; current = target = computeTarget(); applyTime(); request(); }
      if (scrub) {
        scrub.addEventListener("loadedmetadata", markReady);
        scrub.addEventListener("loadeddata", markReady);
        if (scrub.readyState >= 1) markReady();
      }
      window.addEventListener("scroll", request, { passive: true });
      window.addEventListener("resize", request);
      request();
      steps.forEach(function (s, i) {
        s.addEventListener("click", function () {
          var r = sect.getBoundingClientRect();
          var top = window.scrollY + r.top;
          var frac = (i + 0.5) / steps.length;
          var dest = top - window.innerHeight * 0.85 + frac * (r.height + window.innerHeight * 0.7);
          if (lenis) lenis.scrollTo(dest, { duration: 1.1 }); else window.scrollTo({ top: dest, behavior: "smooth" });
        });
      });
    });
  }

  /* ------------------------------------------------------------- Parallax */
  var plx = [];
  function initParallax(root) {
    if (RM) return;
    $$("[data-parallax]", root).forEach(function (el) { if (once(el)) plx.push(el); });
  }
  var pTick = false;
  function runP() {
    pTick = false;
    var vh = window.innerHeight;
    plx = plx.filter(function (el) { return el.isConnected; });
    plx.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var sp = parseFloat(el.dataset.parallax) || 0.16;
      var mid = r.top + r.height / 2 - vh / 2;
      el.style.transform = "translate3d(0," + (-mid * sp).toFixed(2) + "px,0)";
    });
  }
  window.addEventListener("scroll", function () { if (plx.length && !pTick) { pTick = true; requestAnimationFrame(runP); } }, { passive: true });
  window.addEventListener("resize", runP);

  /* -------------------------------------------------------------- 3D tilt */
  var canHover = window.matchMedia("(hover:hover)").matches;
  function initTilt(root) {
    if (RM || !canHover) return;
    $$("[data-tilt]", root).forEach(function (el) {
      if (!once(el)) return;
      var max = parseFloat(el.dataset.tilt) || 8, rect = null;
      el.style.transformStyle = "preserve-3d";
      el.addEventListener("pointerenter", function () { rect = el.getBoundingClientRect(); });
      el.addEventListener("pointermove", function (e) {
        if (!rect) rect = el.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width - 0.5, py = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.transform = "perspective(900px) rotateY(" + (px * max).toFixed(2) + "deg) rotateX(" + (-py * max).toFixed(2) + "deg) translateZ(14px)";
      });
      el.addEventListener("pointerleave", function () {
        rect = null;
        el.style.transition = "transform .7s cubic-bezier(.16,1,.3,1)";
        el.style.transform = "";
        setTimeout(function () { el.style.transition = ""; }, 720);
      });
    });
    $$("[data-magnetic]", root).forEach(function (el) {
      if (!once(el)) return;
      el.addEventListener("pointermove", function (e) {
        var r = el.getBoundingClientRect();
        el.style.transform = "translate(" + ((e.clientX - r.left - r.width / 2) * 0.16).toFixed(1) + "px," + ((e.clientY - r.top - r.height / 2) * 0.22).toFixed(1) + "px)";
      });
      el.addEventListener("pointerleave", function () { el.style.transform = ""; });
    });
  }

  /* ----------------------------------------------- Reels: loop, always on */
  function reelVids() { return $$("video[data-loop]"); }
  function keepPlaying() {
    reelVids().forEach(function (v) {
      if (document.hidden) { v.pause(); return; }
      if (RM) return;
      if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
  }
  function initReels(root) {
    $$("video[data-loop]", root).forEach(function (v) {
      if (!once(v)) return;
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute("muted", ""); v.setAttribute("playsinline", "");
      v.addEventListener("canplay", keepPlaying);
      v.addEventListener("pause", function () { if (!document.hidden) setTimeout(keepPlaying, 90); });
    });
    keepPlaying();
  }
  document.addEventListener("visibilitychange", keepPlaying);
  window.addEventListener("focus", keepPlaying);
  document.addEventListener("click", keepPlaying, { once: true });
  setInterval(function () { if (reelVids().length) keepPlaying(); }, 2500);

  /* ------------------------------------------------------------- Lightbox */
  function openLightbox(src) {
    var lb = $("#lightbox"); if (!lb || !src) return;
    var v = $("video", lb);
    v.innerHTML = '<source src="' + src + '" type="video/mp4">';
    v.load(); lb.classList.add("is-on");
    v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {});
    lockScroll(true);
  }
  function closeLightbox() {
    var lb = $("#lightbox"); if (!lb || !lb.classList.contains("is-on")) return;
    lb.classList.remove("is-on"); $("video", lb).pause(); lockScroll(false);
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-lightbox]");
    if (t) { openLightbox(t.dataset.lightbox); return; }
    if (e.target.closest("[data-lightbox-close]") || e.target.id === "lightbox") closeLightbox();
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeLightbox();
    if ((e.key === "Enter" || e.key === " ") && e.target.matches && e.target.matches("[data-lightbox]")) { e.preventDefault(); openLightbox(e.target.dataset.lightbox); }
  });

  /* -------------------------------------------------------- Number ticker */
  function initCounters(root) {
    $$("[data-count]", root).forEach(function (el) {
      if (!once(el)) return;
      var to = parseFloat(el.dataset.count), suf = el.dataset.suffix || "";
      if (!ANIM || !A() || !("IntersectionObserver" in window)) { el.textContent = to + suf; return; }
      el.textContent = "0";
      var o = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return; o.disconnect();
          var cur = { v: 0 };
          A()({ targets: cur, v: to, duration: 1900, easing: "cubicBezier(.16,1,.3,1)",
            update: function () { el.textContent = Math.round(cur.v).toLocaleString("en-IN") + suf; } });
        });
      }, { threshold: 0.4 });
      o.observe(el);
    });
  }

  /* ------------------------------------------------------- Testimonials nav */
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-tprev],[data-tnext]");
    if (!b) return;
    var wrap = b.closest(".social") || document;
    var strip = $("[data-tstrip]", wrap); if (!strip) return;
    var d = b.hasAttribute("data-tprev") ? -1 : 1;
    strip.scrollBy({ left: d * (strip.firstElementChild ? strip.firstElementChild.offsetWidth + 16 : 280), behavior: "smooth" });
  });

  /* ---------------------------------------------------------- Accordions */
  document.addEventListener("click", function (e) {
    var h = e.target.closest(".acc__h");
    if (!h) return;
    var acc = h.closest("[data-acc]"); if (!acc) return;
    var open = acc.classList.toggle("is-open");
    h.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* ------------------------------------------------------------- Boot */
  function initAll(root) {
    root = root || document;
    initHeader(); initReveals(root); initHero(root); initScrub(root);
    initParallax(root); initTilt(root); initReels(root); initCounters(root);
    runP();
  }
  // Scripts are deferred and run in order, so the DOM is parsed and anime.js
  // and Lenis have already executed by the time this runs.
  initAll();

  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var acc = e.target.closest && e.target.closest("[data-acc]");
    if (acc) acc.classList.add("is-open");
  });
})();
